import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  /** Remove max-width constraint — content stretches to fill available width */
  fullWidth?: boolean;
  /** Remove all padding, margin, and spacing — content goes edge-to-edge */
  noPadding?: boolean;
}

export function PageContainer({ children, className, fullWidth, noPadding }: PageContainerProps) {
  return (
    <div className={cn(
      noPadding ? "" : "space-y-6",
      noPadding ? "" : fullWidth ? "px-2 py-4 md:px-6 md:py-6" : "px-2 py-4 md:p-6 max-w-7xl mx-auto",
      className,
    )}>
      {children}
    </div>
  );
}

